import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4192e6d4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "course-group-box"
};
const _hoisted_2 = {
  class: "module-top"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = {
  key: 0,
  class: "group-carousel"
};
const _hoisted_6 = {
  class: "group-list"
};
const _hoisted_7 = ["onClick"];

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-opacity"
}, null, -1));

const _hoisted_9 = {
  class: "group-content"
};
const _hoisted_10 = {
  class: "name"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "line"
}, null, -1));

const _hoisted_12 = {
  class: "other"
};
const _hoisted_13 = {
  class: "other"
};
const _hoisted_14 = {
  key: 1,
  class: "group-empty"
};
import { ZhsEmpty } from 'zhs-component-library';
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const $utils = inject('$utils');
    const courseGroupList = ref([]);

    const handleDetail = id => {
      window.open(`/courseGroupDetail.html?menuId=${props.menu.menu_id}&name=${props.menu.module_name}&groupSiteId=${id}`);
    };

    const getHomeCourseGroup = async () => {
      const list = await $http.getHomeCourseGroup({
        num: props.menu.num,
        menu_id: props.menu.menu_id
      });
      courseGroupList.value = list ? $utils.arrayGroup(list, 3) : [];
    };

    getHomeCourseGroup();
    return (_ctx, _cache) => {
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");

      const _component_el_carousel = _resolveComponent("el-carousel");

      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(__props.menu.module_name), 1), _createElementVNode("a", {
        href: `/courseGroupList.html?menuId=${__props.menu.menu_id}&name=${__props.menu.module_name}`,
        class: "right"
      }, "全部>", 8, _hoisted_4)]), courseGroupList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_carousel, {
        autoplay: true,
        height: "280px",
        arrow: "never"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseGroupList.value, (group, index) => {
          return _openBlock(), _createBlock(_component_el_carousel_item, {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, item => {
              return _openBlock(), _createElementBlock("div", {
                class: "group-card",
                style: _normalizeStyle({
                  'background-image': `url(${item.groupCoverUrl})`
                }),
                key: item.id,
                onClick: $event => handleDetail(item.siteId)
              }, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.groupName), 1), _hoisted_11, _createElementVNode("div", _hoisted_12, "所属类别：" + _toDisplayString(item.majorName), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.roleName1 + '：' + (item.userNames1 || '')), 1)])], 12, _hoisted_7);
            }), 128))])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_createVNode(_unref(ZhsEmpty))]))]);
    };
  }

};